import styled, { css } from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';
import { Menu } from 'antd';

// Import components
import { Button } from 'components/elements';

// Import styles utilities
import { customResponsive, transitionMain, media, spaceX, flex, size } from 'components/styles';

// Import icons
import { ReactComponent as IconLeft } from 'assets/icons/ic_arrow_l.svg';

const ITEM_MODIFIERS = {
	distinctive: ({ theme }) => css`
		> a {
			color: ${theme.dropdown.menu.itemColorDistinctive};

			&.active-drop-nav {
				background-color: ${({ isMobile, theme: { dropdown } }) =>
					isMobile ? dropdown.menu.itemHoverBgMobile : dropdown.menu.itemHoverBgDistinctive};
				color: ${theme.dropdown.menu.itemActiveColor};
			}
		}

		/* styles below prevents sketchy color transition on hover in antd component */
		&.ant-dropdown-menu-item-active {
			background: none;

			> a {
				background-color: ${theme.dropdown.menu.itemHoverBgDistinctive};
				color: ${theme.dropdown.menu.itemHoverColorDistinctive};
			}
		}
	`
};

export const ItemStyled = styled(Menu.Item)`
	${({ isMobile }) =>
		isMobile &&
		css`
			&:active {
				background-color: ${({ theme: { dropdown } }) => dropdown.menu.itemHoverBgMobile};
			}
			&.ant-menu-item.ant-menu-item-active {
				background-color: ${({ theme: { dropdown } }) => dropdown.menu.itemHoverBgMobile};
				&:hover {
					background-color: ${({ theme: { dropdown } }) => dropdown.menu.itemHoverBgMobile};
				}
			}
		`}

	> a {
		color: ${({ theme }) => theme.grayMedium};
		${transitionMain}
		${({ isMobile }) =>
			isMobile &&
			css`
				padding: 1.2rem 0;
				width: 100%;
			`}

		&.active-drop-nav {
			background-color: ${({ theme: { dropdown }, isMobile }) => (isMobile ? dropdown.menu.itemHoverBgMobile : dropdown.menu.itemHoverBg)};
			color: ${({ theme: { dropdown } }) => dropdown.menu.itemHoverColor};
		}
	}

	/* styles below prevents sketchy color transition on hover */
	&.ant-dropdown-menu-item-active {
		background: none;

		> a {
			background-color: ${({ theme: { dropdown }, isMobile }) => (isMobile ? dropdown.menu.itemHoverBgMobile : dropdown.menu.itemHoverBg)};
			color: ${({ theme: { dropdown } }) => dropdown.menu.itemHoverColor};
		}
	}

	${applyStyleModifiers(ITEM_MODIFIERS)};
`;

export const NavDropdownStyled = styled.div`
	display: none;

	${customResponsive(
		1365,
		css`
			display: flex;
			align-items: center;
			padding: 0.8rem;
			margin-bottom: 0;
		`
	)}

	${customResponsive(
		size.small,
		css`
			justify-content: center;
			margin-bottom: 1rem;
		`
	)}
`;

export const Text = styled.span`
	color: ${({ theme }) => theme.grayMedium};
	font-weight: ${({ theme }) => theme.font.normal};
	font-size: ${({ theme: { dropdown } }) => dropdown.menu.fontSize}rem;
	margin-right: 1.5rem;
`;

export const IconDown = styled(IconLeft)`
	height: 1.5rem;
	transform: rotate(-90deg);

	polygon {
		${transitionMain}
	}
`;

export const ButtonStyled = styled(Button)`
	text-transform: capitalize;

	&:hover,
	&.ant-dropdown-open {
		color: ${({ theme: { dropdown } }) => dropdown.button.colorHover};

		${IconDown} {
			polygon {
				fill: ${({ theme }) => theme.white};
			}
		}
	}
`;

export const MenuStyled = styled(Menu)`
	${({ isMobile }) =>
		isMobile &&
		css`
			padding: 1rem 2rem 2rem;
		`}
`;

export const DrawerWrapper = styled.div`
	padding-top: 3rem;
	${flex({ jc: 'space-around' })}
	${spaceX(0)}
	${media.min.xmin(css`
		justify-content: flex-start;
		margin-left: 1rem;
		${spaceX(12)}
	`)}
`;
